import { useAuth } from "../AuthContext";
import { useLoginModal } from "../LoginModalContext";

const INTERACTIVE_SELECTOR = "a, button, input, select, textarea, .btn, [data-bs-toggle], [data-bs-target]";

const ALLOWED_SELECTOR = ".owl-nav, .owl-dots, .homeCustom-nav, [data-guest-allow]";

const DEFAULT_COPY = {
  title: "Login to Continue",
  heading: "Welcome. Please Login!",
  description: "Enter below details to continue your account",
};

export const useGuestLoginPrompt = (copy = DEFAULT_COPY) => {
  const { isAuthenticated } = useAuth();
  const { showLoginModal } = useLoginModal();

  return () => {
    if (isAuthenticated !== false) return false;
    showLoginModal(copy);
    return true;
  };
};

export const useGuestClickGuard = (copy = DEFAULT_COPY) => {
  const { isAuthenticated } = useAuth();
  const promptLogin = useGuestLoginPrompt(copy);

  return (event) => {
    if (isAuthenticated !== false) return;

    const target = event.target;
    if (!target || typeof target.closest !== "function") return;
    if (target.closest(ALLOWED_SELECTOR)) return;
    if (!target.closest(INTERACTIVE_SELECTOR)) return;

    event.preventDefault();
    event.stopPropagation();
    promptLogin();
  };
};
